'use client';

import { Box, Tooltip } from '@mui/material';
import type { SqlQueryExecutionStatus } from '@repo/api-gw-sdk';
import React from 'react';

interface QueryExecutionStatusConfig {
  title: string;
  iconColor: string;
  backgroundColor: string;
  icon: string;
}

const queryExecutionStatusConfig: Record<string, QueryExecutionStatusConfig> = {
  QUEUED: {
    title: 'Queued',
    iconColor: 'var(--mui-palette-info-main)',
    backgroundColor: 'var(--mui-palette-info-opacity)',
    icon: 'material-symbols-avg-pace-rounded',
  },
  RUNNING: {
    title: 'Running',
    iconColor: 'var(--mui-palette-info-main)',
    backgroundColor: 'var(--mui-palette-info-opacity)',
    icon: 'material-symbols-avg-pace-rounded',
  },
  SUCCEEDED: {
    title: 'Succeeded',
    iconColor: 'var(--mui-palette-success-main)',
    backgroundColor: 'var(--mui-palette-success-opacity)',
    icon: 'material-symbols-check-circle-outline-rounded',
  },
  FAILED: {
    title: 'Failed',
    iconColor: 'var(--mui-palette-error-main)',
    backgroundColor: 'var(--mui-palette-error-opacity)',
    icon: 'material-symbols-disc-full-outline-rounded',
  },
  CANCELLED: {
    title: 'Cancelled',
    iconColor: 'var(--mui-palette-custom-GREY-01)',
    backgroundColor: 'var(--mui-palette-custom-GREY-OPACITY)',
    icon: 'material-symbols-do-not-disturb-on-outline-rounded',
  },
};

export const QueryExecutionStatusCell = React.forwardRef<
  HTMLSpanElement,
  {
    status: SqlQueryExecutionStatus;
    hideTooltip?: boolean;
  }
>(({ status, hideTooltip }, ref) => {
  const config = queryExecutionStatusConfig[status];
  if (!config) {
    return null;
  }

  return (
    <Tooltip title={hideTooltip ? undefined : config.title}>
      <Box
        ref={ref}
        component='span'
        className='rounded-full inline-flex p-[2px]'
        sx={{
          background: config.backgroundColor,
          '& i': {
            background: config.iconColor,
          },
        }}
      >
        <i className={`${config.icon} h-[20px] w-[20px]`} />
      </Box>
    </Tooltip>
  );
});

QueryExecutionStatusCell.displayName = 'QueryExecutionStatusCell';
